import { render, staticRenderFns } from "./ClientHistoryProducts.vue?vue&type=template&id=59af593c&scoped=true"
import script from "./ClientHistoryProducts.vue?vue&type=script&lang=js"
export * from "./ClientHistoryProducts.vue?vue&type=script&lang=js"
import style0 from "./ClientHistoryProducts.vue?vue&type=style&index=0&id=59af593c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59af593c",
  null
  
)

export default component.exports